const stats = [
  { num: "<30", unit: "Sekunden, bis Ihre Anrufer eine echte Stimme hören." },
  { num: "24", unit: "Stunden erreichbar - auch nachts und am Wochenende." },
  { num: "9", unit: "von 10 Anliegen lösen wir direkt im ersten Gespräch." },
  { num: "1", unit: "anruf am Tag - unser kleinstes projekt, >4000 Anrufe - unser grösstes. " },
];

export default function StatsSecond() {
  return (
    <section
      data-stage="3b"
      className="relative py-8 md:py-12 px-6 md:px-12 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto">
        <div
          data-reveal
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16"
        >
          <div>
            <span className="text-xs tracking-[0.4em] uppercase text-moss mb-4 block">
              · ZAHLEN, DIE SIE KENNENLERNEN SOLLTEN
            </span>
            <h2 className="font-display text-4xl md:text-6xl font-light leading-tight">
              Die gefallen Ihnen besser.
            </h2>
          </div>
          <p className="text-inkDim text-sm max-w-xs leading-relaxed">
            Diese Zahlen haben wir uns nicht ausgedacht.
            Sie kommen aus unseren Projekten.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line rounded-2xl overflow-hidden border border-line">
          {stats.map((s, i) => (
            <div
              key={s.unit}
              data-reveal
              data-delay={i + 1}
              className="bg-bg/80 px-6 py-10 md:py-14 hover:bg-bgSoft transition-colors group"
            >
              <div className="font-display text-5xl md:text-6xl text-ink font-light tabular-nums mb-3 group-hover:text-sage transition-colors">
                {s.num}
              </div>
              <div className="text-sm text-ink/80 uppercase tracking-[0.2em] mb-2">
                {s.unit}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}